<template>
  <form @submit.prevent="handleSubmit(item)">
    <div class="form-group">
      <label
        for="exsboperation_state"
        class="form-control-label">state</label>
      <input
        id="exsboperation_state"
        v-model="item.state"
        :class="['form-control', isInvalid('state') ? 'is-invalid' : '']"
        type="number"
        placeholder=""
        @input="handleUpdateField('state', $event.target.value)">
      <div
        v-if="isInvalid('state')"
        class="invalid-feedback">{{ violations.state }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsboperation_createdAt"
        class="form-control-label">createdAt</label>
      <input
        id="exsboperation_createdAt"
        v-model="item.createdAt"
        :class="['form-control', isInvalid('createdAt') ? 'is-invalid' : '']"
        type="dateTime"
        placeholder=""
        @input="handleUpdateField('createdAt', $event.target.value)">
      <div
        v-if="isInvalid('createdAt')"
        class="invalid-feedback">{{ violations.createdAt }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsboperation_updatedAt"
        class="form-control-label">updatedAt</label>
      <input
        id="exsboperation_updatedAt"
        v-model="item.updatedAt"
        :class="['form-control', isInvalid('updatedAt') ? 'is-invalid' : '']"
        type="dateTime"
        placeholder=""
        @input="handleUpdateField('updatedAt', $event.target.value)">
      <div
        v-if="isInvalid('updatedAt')"
        class="invalid-feedback">{{ violations.updatedAt }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsboperation_deletedAt"
        class="form-control-label">deletedAt</label>
      <input
        id="exsboperation_deletedAt"
        v-model="item.deletedAt"
        :class="['form-control', isInvalid('deletedAt') ? 'is-invalid' : '']"
        type="dateTime"
        placeholder=""
        @input="handleUpdateField('deletedAt', $event.target.value)">
      <div
        v-if="isInvalid('deletedAt')"
        class="invalid-feedback">{{ violations.deletedAt }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsboperation_createdBy"
        class="form-control-label">createdBy</label>
      <input
        id="exsboperation_createdBy"
        v-model="item.createdBy"
        :class="['form-control', isInvalid('createdBy') ? 'is-invalid' : '']"
        type="number"
        placeholder=""
        @input="handleUpdateField('createdBy', $event.target.value)">
      <div
        v-if="isInvalid('createdBy')"
        class="invalid-feedback">{{ violations.createdBy }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsboperation_updatedBy"
        class="form-control-label">updatedBy</label>
      <input
        id="exsboperation_updatedBy"
        v-model="item.updatedBy"
        :class="['form-control', isInvalid('updatedBy') ? 'is-invalid' : '']"
        type="number"
        placeholder=""
        @input="handleUpdateField('updatedBy', $event.target.value)">
      <div
        v-if="isInvalid('updatedBy')"
        class="invalid-feedback">{{ violations.updatedBy }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsboperation_deletedBy"
        class="form-control-label">deletedBy</label>
      <input
        id="exsboperation_deletedBy"
        v-model="item.deletedBy"
        :class="['form-control', isInvalid('deletedBy') ? 'is-invalid' : '']"
        type="number"
        placeholder=""
        @input="handleUpdateField('deletedBy', $event.target.value)">
      <div
        v-if="isInvalid('deletedBy')"
        class="invalid-feedback">{{ violations.deletedBy }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsboperation_warehouseItem"
        class="form-control-label">warehouseItem</label>
      <input
        id="exsboperation_warehouseItem"
        v-model="item.warehouseItem"
        :class="['form-control', isInvalid('warehouseItem') ? 'is-invalid' : '']"
        type="text"
        placeholder=""
        @input="handleUpdateField('warehouseItem', $event.target.value)">
      <div
        v-if="isInvalid('warehouseItem')"
        class="invalid-feedback">{{ violations.warehouseItem }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsboperation_quantity"
        class="form-control-label">quantity</label>
      <input
        id="exsboperation_quantity"
        v-model="item.quantity"
        :class="['form-control', isInvalid('quantity') ? 'is-invalid' : '']"
        type="number"
        placeholder=""
        @input="handleUpdateField('quantity', $event.target.value)">
      <div
        v-if="isInvalid('quantity')"
        class="invalid-feedback">{{ violations.quantity }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsboperation_direction"
        class="form-control-label">direction</label>
      <input
        id="exsboperation_direction"
        v-model="item.direction"
        :class="['form-control', isInvalid('direction') ? 'is-invalid' : '']"
        type="number"
        placeholder=""
        @input="handleUpdateField('direction', $event.target.value)">
      <div
        v-if="isInvalid('direction')"
        class="invalid-feedback">{{ violations.direction }}</div>
    </div>

    <button
      type="submit"
      class="btn btn-primary">Submit</button>
  </form>
</template>

<script>
export default {
  props: {
    handleSubmit: {
      type: Function,
      required: true
    },

    handleUpdateField: {
      type: Function,
      required: true
    },

    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    // eslint-disable-next-line
    item () {
      return this.initialValues || this.values
    },

    violations () {
      return this.errors || {}
    }
  },

  methods: {
    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    }
  }
}
</script>
